import { render, staticRenderFns } from "./FormPaymentGeneralKasbon.vue?vue&type=template&id=84470ccc"
import script from "./FormPaymentGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./FormPaymentGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports